import { Component, Input } from "@angular/core";
import { CoreMenuItem } from "src/app/menu/core-menu";

@Component({
    selector: "app-header-menu-item",
    templateUrl: "./menu-item.component.html",
    styleUrl: "./menu-item.component.scss",
    standalone: false
})
export class HeaderMenuItemComponent {
  @Input() menu: CoreMenuItem;
  @Input() isShowIcon: boolean = true;
}
